<template>
  <div class="notifyRemote">
    <div class="content active" @click="clicked()">
      <i class="arrow-down fa fa-bell"></i>
    </div>
    <div
      class="ball"
      v-if="notify.read.filter((n) => !n.visualizado).length > 0"
    >
      {{ notify.read.filter((n) => !n.visualizado).length }}
    </div>
    <transition name="fade">
      <div class="container" v-if="showTab">
        <ul class="tab">
          <li v-if="!notify.read.length && !notify.readed.length">
            Não há notificações
          </li>
          <li
            v-for="(n, i) of notify.read"
            :key="'n' + i"
            class="row"
            :class="(n.id && 'clickable') + ' ' + (!n.visualizado && 'new')"
            @click="openNotify(n)"
          >
            <div class="grid-2 text-center">
              <b>{{ n.time }}</b>
            </div>
            <div class="grid-2"></div>
            <div class="grid-7">{{ n.msg }}</div>
          </li>
        </ul>
      </div>
    </transition>
    <div class="mask" @click="clicked()" v-if="showTab"></div>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from "vuex";

export default {
  name: "Notify",
  data() {
    return {
      showTab: false,
    };
  },
  beforeMount() {
    /* this.GET_COMMS(this.user.id).then((r) => {
      if (r.status == 200) {
        for (let comm of r.data) {
          this.SET_NOTIFY(comm);

          if (comm.destaque && !comm.visualizado) {
            this.GET_COMM(comm.id_comunicado).then((template) => {
              this.SET_MODALS({
                ...comm,
                content: template.data,
                show: true,
                layout: "Comm",
              });
            });
          }
        }
      }
    }); */
  },
  methods: {
    ...mapActions("general", ["GET_COMM", "GET_COMMS"]),
    ...mapMutations("general", [
      "SET_NOTIFY_READED",
      "CLEAR_NOTIFY",
      "SET_NOTIFY",
      "SET_MODALS",
    ]),
    clicked() {
      this.showTab = !this.showTab;
      if (!this.showTab)
        this.notify.read.map((n) => {
          if (!n.id_comunicado) n.visualizado = true;
        });
    },
    openNotify(notify) {
      if (notify.id_comunicado) {
        this.clicked();
        this.GET_COMM(notify.id_comunicado).then((template) => {
          this.SET_MODALS({
            ...notify,
            content: template.data,
            show: true,
            layout: "Comm",
          });
        });
      }
    },
  },
  computed: {
    ...mapGetters("general", ["notify"]),
    ...mapGetters("user", ["user"]),
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;

.notifyRemote {
  margin-left: 25px;

  .clear {
    font-size: 0.8rem;
    text-align: center;
    padding: 0.8rem 0rem;
    color: $gray-4;
    letter-spacing: 0.1rem;
    font-weight: bold;
    &:hover {
      cursor: pointer;
      background: $green-1;
      color: $white;
    }
  }
  .content {
    width: 37px;
    height: 37px;
    text-align: center;
    line-height: 36px;
    cursor: pointer;
    background: rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    color: #fff;
  }
  .mask {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: 900;
  }
  .ball {
    margin-top: -42px !important;
    margin-right: -5px !important;
    float: right;
    border-radius: 50%;
    font-size: 12px;
    min-width: 20px;
    height: 20px;
    line-height: 17px;
    font-weight: bold;
    text-align: center;
    margin-top: -42px;
    margin-right: -7px;
    color: $white;
    background: $red-1;
  }

  &-content {
    padding: 10px 12px;
    border-radius: 50%;
    &.active {
      background: $green-1;
      color: $white;
    }
  }
  .container {
    padding-top: 14px;
    @media (max-width: $small) {
      right: 0px;
      left: 0px;
    }
    @media (min-width: $small) {
      margin-left: -185px;
      border-radius: 3px;
    }
    position: absolute;
    box-shadow: $shadow;
    z-index: 999;
    background: $white;
    margin-top: 12px;

    @media (min-width: $small) {
      &:before {
        top: -8px;
        content: " ";
        position: absolute;
        display: block;
        border: 10px solid #fff;
        transform: rotate(45deg);
        left: 195px;
      }
    }

    .tab {
      @media (max-width: $small) {
        width: 100%;
      }
      width: 400px;
      max-height: 260px;
      overflow: auto;

      li {
        padding: 15px 10px;
        color: $gray-4;
        border-bottom: 1px solid $white-3;
        &.clickable:hover {
          cursor: pointer;
          background: $white-10;
        }
        &.new {
          background-color: $green-3;
          /* color: $white; */
        }
      }
    }
  }
}
</style>